import values from "../values";

import { Layout } from "../components";
import { NotFound } from "../screen";
import { Navigate, Route, Routes } from "react-router-dom";

import ServiceContainer from "../screen/ServiceScreen/Container/SuperAgent.Container";
import CompanyContainer from "../screen/CompanyScreen/Container/SuperAgent.container";
import SchoolContainer from "../screen/SchoolScreen/Container";
import DriverContainer from "../screen/DriverScreen/Container/SuperAgent.container";
import DashboardContainer from "../screen/DashboardScreen/container";
import ParentContainer from "../screen/ParentScreen/Container/SuperAgent.container";
//import ParentContainer from "../screen/ParentScreen/Container";

const MunicipalityRoute = () => {
  return (
    <Layout topMenuItems={values.topMenuItems.TOP_MENU_ROLE_Municipality}>
      <Routes>
        <Route path="/" element={<Navigate to={"driver"} />} />
        <Route path="/service/*" element={<ServiceContainer />} />
        <Route path="/company/*" element={<CompanyContainer />} />
        <Route path="/parents/*" element={<ParentContainer />} />
        <Route path="/school/*" element={<SchoolContainer />} />
        <Route path="/driver/*" element={<DriverContainer />} />
        <Route path="/dashboard/*" element={<DashboardContainer />} />
        <Route path="/*" element={<NotFound />} />
      </Routes>
    </Layout>
  );
};

export default MunicipalityRoute;
